// Default imports
import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import GenericSection from "../components/GenericSection";
import GenericWideSection from "./GenericWideSection";
import WpImageFluid from "./WpImageFluid";
import ContentBox from "./ContentBox";
import ComparisonTableHtml from "./ComparisonTableHtml";

import slugify from "slugify";
import SectionHeader from "./SectionHeader";

const ImageSection = ({ imageSection, ...props }) => {
    switch (imageSection?.variant) {
        case "blue-box":
        case "no-box":
        case "table":
            return <ImageSectionWithTextBoxed {...imageSection} {...props} />;

        case "no-box-full-width":
            return (
                <ImageSectionWithTextBoxedFullWidth
                    {...imageSection}
                    {...props}
                />
            );

        case "oversize-grey-background":
            return <ImageSectionWithText {...imageSection} {...props} />;

        case "wide":
            return <ImageSectionWide {...imageSection} {...props} />;

        case "wide-vertical":
            return <ImageSectionWide vertical {...imageSection} {...props} />;

        case "full-width":
            return (
                <ImageSectionWide
                    vertical
                    containerClassName="-full-width"
                    {...imageSection}
                    {...props}
                />
            );

        default:
            return <></>;
    }
};

const ImageSectionWide = ({ title, image, ...props }) => (
    <GenericWideSection
        {...props}
        header={title}
        smallContent={!props?.vertical}
        containerClassName={`-empower-section ${
            props?.containerClassName || ""
        }`}
        contentClassName={`-wide ${props?.contentClassName || ""}`}
    >
        <WpImageFluid
            className={`image-section__image w-100`}
            image={image}
            style={{ width: "100%", maxWidth: "none" }}
        />
    </GenericWideSection>
);

const ImageSectionWithText = ({ title, image, ...props }) => (
    <GenericSection header={title} {...props}>
        <WpImageFluid className={`image-section__image `} image={image} />
    </GenericSection>
);

const ImageSectionWithTextBoxed = ({
    title,
    slug,
    category,
    text,
    image,
    button,
    variant,
    flipped,
    items,
    centerMobile,
    noMaxHeight,
}) => {
    const isTable = variant === "table";

    return (
        <Container
            id={
                slug ||
                slugify(
                    items
                        ? items.map((item) => item.title).join("--")
                        : title || "image-section",
                    {
                        lower: true,
                        strict: true,
                        locale: "pl",
                    }
                )
            }
        >
            {category && (
                <div className="image-section__tag">{category}</div>
            )}
            {title && (
                <SectionHeader
                    header={title}
                    className="image-section__header"
                />
            )}
            {text && (
                <div
                    className="image-section__intro"
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            )}
            <Row
                className={`image-section -${variant} ${flipped && "-flipped"}${noMaxHeight ? " -no-image-max-height" : ""}`}
            >
                <Col
                    xs="24"
                    md="24"
                    lg="10"
                    xl={isTable ? "9" : "10"}
                    className={`image-section__content-col${centerMobile ? " -center-mobile" : ""}`}
                >
                    {items?.map((item) => (
                        <ContentBox
                            key={item.title}
                            variant={isTable ? "no-box" : variant}
                            button={button}
                            displayLogo={variant === "blue-box"}
                            {...item}
                        />
                    ))}
                </Col>

                <Col
                    xs="24"
                    md="24"
                    lg={isTable ? true : "12"}
                    xl={isTable ? true : "9"}
                    className="d-flex justify-content-center cmb-6 cmb-lg-0"
                >
                    {isTable ? (
                        <ComparisonTableHtml />
                    ) : (
                        <WpImageFluid
                            className="image-section__image"
                            image={image}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

const ImageSectionWithTextBoxedFullWidth = ({
    title,
    slug,
    category,
    items,
    text,
    image,
    button,
    variant,
    flipped,
    centerMobile,
    noMaxHeight,
}) => {
    return (
        <Container
            id={
                slug ||
                slugify(
                    items
                        ? items.map((item) => item.title).join("--")
                        : title || "image-section",
                    {
                        lower: true,
                        strict: true,
                        locale: "pl",
                    }
                )
            }
        >
            <Row
                className={`image-section -${variant} ${flipped && "-flipped"}${noMaxHeight ? " -no-image-max-height" : ""}`}
            >
                <Col
                    xs="24"
                    md="24"
                    lg="10"
                    className={`image-section__content-col${centerMobile ? " -center-mobile" : ""} ${
                        flipped && "offset-lg-2"
                    }`}
                >
                    {items &&
                        items.map((item) => (
                            <ContentBox
                                key={item.title}
                                variant={variant}
                                displayLogo={variant === "blue-box"}
                                {...item}
                            />
                        ))}
                    {(title || text) && (
                        <ContentBox
                            variant={variant}
                            displayLogo={variant === "blue-box"}
                            button={button}
                            category={category}
                            text={text}
                            title={title}
                        />
                    )}
                </Col>

                <Col
                    xs="24"
                    md="24"
                    lg="11"
                    className={`d-flex justify-content-center cmb-6 cmb-lg-0 ${
                        !flipped && "offset-lg-2"
                    }`}
                >
                    <WpImageFluid
                        className="image-section__image"
                        image={image}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default ImageSection;
